import Container from '@/landing/component/container/nogap'

import Head from "@helper/seo/head"

const PrivacyPolicy = () => {
  return (
    <Container>
      <Head
        title="SellOn | Privacy Policy"
        type="website"
        url="https://sellon.net/landing/privacy_policy"
        siteName="Sellon Tech"
        image="/media/logo/main.png"
      />
      <h1 className='text-center text-3xl font-bold mb-16'>Privacy Policy</h1>
      <div className='grid gap-3 ml-3 mr-3'>
        <p className="mb-1">
          In this policy, we, Sellon, inform you about our personal data
          collection and use practices relating to your use of SellOn's mobile
          consumer-to-consumer marketplace service. It does not cover other data
          collection or processing by Sellon or data that other companies
          collect or sites or services that are linked from our service.
        </p>
        <div>
          <strong>Changes</strong>
          <p className="mb-1">
            Carefully review this policy. We will amend it from time to time as
            our technology, services, features and business models change, so you
            should review our current privacy policy every time you use our
            service.
          </p>
        </div>
        <div>
          <strong>Children</strong>
          <p className="mb-1"> Children under 18 are not allowed to use the SellOn service. </p>
        </div>
        <div>
          <strong>Account data</strong>
          <p className="mb-1">
            When you sign up for our service, you actively provide us with account
            registration information that you can access and update within the
            SellOn app at any time, including:
          </p>
          <ul className="list-disc list-outside mb-3 ml-5 pl-2">
            <li className='pl-1 -indent-1'>
              Contact information, such as your name, address, phone, and email
            </li>
            <li className='pl-1 -indent-1'>
              Financial information, such as bank account and/or credit card
              numbers
            </li>
          </ul>
          <p className="mb-1">
            We use your email address to communicate with you about transactions,
            new services and other topics we believe are of interest to you. We
            use your mailing address for delivery of items you purchase through
            our service. We collect your credit card or other payment card
            information for payment processing purposes and your bank account
            information to pay when you sell items through our service. We collect
            social network info for login and authentication purposes.
          </p>
          <p className="mb-1">
            We may also update your registration information, for example, if you
            provide a new email or mailing address on your account.
          </p>
          <p className="mb-1">
            We save personal information data on a database through encryption to
            be more secure.(Name of Seller/Buyer, Password, Phone Number, Email, Part
            of Address, Bank Account No.). The photo of Seller/Buyer is saved
            without encryption that means it might be shared with others if
            necessary.
          </p>
        </div>
        <div>
          <strong>Usage data</strong>
          <p className="mb-1">
            When you use the SellOn service, we process and deliver to you and
            other users of our service information about your SellOn transactions,
            such as information about items that you post for sale through our
            service and messages exchanged with other SellOn users. In this
            context, we receive information about your device, software, who you
            communicate with, message content, locations and our access logs,
            which includes IP address, device ID, your actions within our service
            and language settings.
          </p>
          <p className="mb-1">
            We process usage information to deliver, improve and optimize our
            SellOn service, to protect you, us and other users from actual or
            potential fraud and misuse, and to determine what information,
            features, promotional information and other services you need or may
            be interested in.
          </p>
        </div>
        <div>
          <strong>Third party sources</strong>
          <p className="mb-1">
            We may combine your usage data with information we collect from other
            companies such as Google Analytics to customize and improve your user
            experience. Google Analytics collects information regarding the use of
            apps and online resources ( For more information, please visit&nbsp;
            <a className="text-blue-700" href="https://policies.google.com/privacy/partners">
              https://policies.google.com/privacy/partners
            </a>
            .)
          </p>
          <p className="mb-1">
            You may choose to provide us with access to certain personal
            information stored by third parties such as social media sites (e.g.,
            Facebook&nbsp;
            <a className="text-blue-700" href="https://www.facebook.com/policy.php">
              https://www.facebook.com/policy.php
            </a>
            ). The information we may receive varies by site and is controlled by
            that site. By associating an account managed by a third party with
            your SellOn account and authorizing SellOn to have access to this
            information, you agree that we may collect, store and use this
            information in accordance with this Privacy Policy.
          </p>
        </div>
        <div>
          <strong>Data retention and access</strong>
          <p className="mb-1">
            You can review and edit your personal information at any time by
            logging in to your account and reviewing your account settings.
          </p>
          <p className="mb-1">
            We retain account and usage data as long as required by applicable
            law. We may retain personal information from your account to collect
            any fees owed, resolve disputes, complete investigations, prevent
            fraud, enforce our Terms of Service User Agreement, or take other
            actions as required or permitted by law.
          </p>
        </div>
        <div>
          <strong>Disclosures, sharing</strong>
          <p className="mb-1">
            We do not disclose your individual account or usage data to third
            parties, except:
          </p>
          <ul className="list-disc list-outside ml-5 pl-2">
            <li className='pl-1 -indent-1'>with your consent or at your direction.</li>
            <li className='pl-1 -indent-1'>as necessary to collect payment.</li>
            <li className='pl-1 -indent-1'> to process a product requested by you or otherwise provide our service to you. </li>
            <li className='pl-1 -indent-1'>
              to enable service providers under contract to facilitate operations, such as fraud prevention &amp; risk management, bill collection, marketing, customer service and technology services.
            </li>
            <li className='pl-1 -indent-1'> as necessary to resolve a problem between SellOn users or with third parties. </li>
            <li className='pl-1 -indent-1'>as required by law or to assert or protect legal rights.</li>
            <li className='pl-1 -indent-1'>
              to comply with anti-money laundering and counter-terrorist financing verification requirements.
            </li>
            <li className='pl-1 -indent-1'>
              as necessary to protect you, other users, us or third parties from actual or potential harm, including fraud, data security or confidentiality breaches, other liability, or where someone's physical safety seems at risk.
            </li>
            <li className='pl-1 -indent-1'>to maintain or service your account.</li>
            <li className='pl-1 -indent-1'>
              as otherwise permitted by law.
            </li>
          </ul>
        </div>
        <div>
          <strong>Security</strong>
          <p className="mb-1">
            We take required steps to protect your account information and account
            messages and to protect against data loss, misuse and unauthorized
            access. However, no internet transmission is ever completely secure or
            error-free. In particular, messages sent through the SellOn service
            are not encrypted.
          </p>
          <p className="mb-1">
            It is your responsibility to control access to your device, including
            keeping your login information confidential and not sharing it with
            anyone. It is also your responsibility to notify SellOn if you believe
            the security of the information in the SellOn app or your SellOn
            account has been compromised.
          </p>
          <div className='mt-2'>
            <strong>Leave or delete accounts</strong>
          </div> 
          <p className='mb-1'>
            We provide customers with the option to delete their accounts on their own. To delete your account, please follow these steps: Navigate to the side menu, click on "SETTING", and then select "Delete Account".
            When you select "Delete Account" on Sellon, we ensure the complete deletion of your data, making it irrecoverable.
          </p>
        </div>
      </div>
    </Container>
  );
};

export default PrivacyPolicy;
